package org.hs_soft.runmynesto.pages.home.sub_page.media_center.component.media_center_content.tabs.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.config.generalDialogSetting
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.media_tab.MediaTag
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CircleIcon
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.components.dialog.component.DialogTitle
import org.jetbrains.compose.web.css.LineStyle

@Composable
fun EditGroupDialog(
    windowSizeMode: WindowSizeModeEnum,
    mediaTags:List<MediaTag>?,
    loading:Boolean,
    deleteTag:(String)->Unit,
    addTag:(String)->Unit,
    closeDialog:()->Unit,
)
{
    val newMediaTags = remember {
        mutableStateOf(mediaTags)
    }
    LaunchedEffect(mediaTags){
        newMediaTags.value=mediaTags
    }

    val newTag= remember { mutableStateOf("") }

    Box(
        modifier = Modifier
            .backgroundDialog()
            .onClick {
                closeDialog()
            }
    )
    {

        Column(
            modifier = Modifier
                .align(Alignment.Center)
                .generalDialogSetting()
                .onClick {
                        event: SyntheticMouseEvent -> event.stopPropagation()
                }
        )
        {

            DialogTitle(
                title = Strings.current().editGroup,
                showCloseIcon =true,
                showSeparator = false,
                onCloseClick = {
                    closeDialog()
                }
            )


            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(
                        leftRight = Dimen.extraLargePadding,
                        bottom = Dimen.extraLargePadding,
                    ),
                horizontalAlignment = Alignment.CenterHorizontally,
            )
            {
                CustomEditText(
                    width = Dimen.largeEditTextWidth,
                    label = Strings.current().addNewGroup,
                    value =newTag.value,
                    endIconPath = Res.PathIcon.add,
                    endIconSize = Dimen.semiLargeIconSize2,
                    fillMaxWidth = true,
                    onEndIconClick = {
                        if (newTag.value.isNotEmpty())
                            addTag(newTag.value)
                    },
                    isOutlinedEditText = true,
                    onFocusIn = {},
                    onFocusOut = {},
                    onInputChange = {it, validation ->
                        newTag.value=it
                    },

                )

                Column(
                    modifier = VerticalScrollBehavior.toModifier()
                        .fillMaxWidth()
                        .height(Dimen.AddGroupDialogItemsHeight)
                )
                {
                    newMediaTags.value?.forEach {
                        GroupItem(
                            title = it.name?:"",
                            deleteItem = {
                                deleteTag(it.id?:"")
                            }
                        )
                    }


                }

                CustomButton(
                    modifier = Modifier
                        .fillMaxWidth(),
                    loading = loading,
                    title = Strings.current().submit,
                    buttonType = ButtonTypes.CONTAINED,
                    onButtonClick = {
                        closeDialog()
                    },
                )


            }

        }





    }
}

@Composable
private fun GroupItem(
    title:String,
    deleteItem:()->Unit,
)
{
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .margin(topBottom = Dimen.smallPadding)
            .padding(leftRight = Dimen.normalPadding)
            .borderRadius(Dimen.lowBorderRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
            .height(Dimen.mediumOutlinedEditTextHeight),
        verticalAlignment = Alignment.CenterVertically
    )
    {
        SpanText(
            text = title,
            modifier = Modifier
                .fontFamily(FontFamily.Jakarta)
                .fontSize(FontSizes.mediumFontSize)
                .color(Theme.TextPrimary.rgb)
        )

        Spacer()

        CircleIcon(
            size = Dimen.normalIconSize,
            img = Res.PathIcon.mediumClose,
            borderColor = Theme.Transparent.rgb,
            onIconClick = {
                deleteItem()
            },
        )

    }




}